import {
    O365_REGISTER_REQUEST,
    O365_REGISTER_SUCCESS,
    O365_LOAD_EVENTS_REQUEST,
    O365_LOAD_EVENTS_SUCCESS,
    O365_LOAD_EVENTS_FAILURE,
    O365_LOAD_EVENT_REQUEST,
    O365_LOAD_EVENT_SUCCESS,
    O365_LOAD_EVENT_FAILURE,
    O365_LOAD_USER_INFO_REQUEST,
    O365_LOAD_USER_INFO_SUCCESS,
    O365_LOAD_USER_INFO_FAILURE,
    O365_CREATE_EVENT_REQUEST,
    O365_CREATE_EVENT_SUCCESS,
    O365_CREATE_EVENT_FAILURE,
    O365_DELETE_EVENT_REQUEST,
    O365_DELETE_EVENT_SUCCESS,
    O365_DELETE_EVENT_FAILURE,
    O365_ACCEPT_EVENT_REQUEST,
    O365_ACCEPT_EVENT_SUCCESS,
    O365_ACCEPT_EVENT_FAILURE,
    O365_TENTATIVE_EVENT_REQUEST,
    O365_TENTATIVE_EVENT_SUCCESS,
    O365_TENTATIVE_EVENT_FAILURE,
    O365_DECLINE_EVENT_REQUEST,
    O365_DECLINE_EVENT_SUCCESS,
    O365_DECLINE_EVENT_FAILURE,
    CORE_LOAD_ORDERS_REQUEST,
    CORE_LOAD_ORDERS_SUCCESS,
    CORE_LOAD_ORDERS_FAILURE,
    CORE_FIND_ROOM_REQUEST,
    CORE_FIND_ROOM_SUCCESS,
    CORE_FIND_ROOM_FAILURE,
    CORE_DELETE_ROOM_REQUEST,
    CORE_DELETE_ROOM_SUCCESS,
    CORE_DELETE_ROOM_FAILURE,
    CORE_LOAD_USER_REQUEST,
    CORE_LOAD_USER_SUCCESS,
    CORE_LOAD_USER_FAILURE,
    CORE_LOAD_USERS_REQUEST,
    CORE_LOAD_USERS_SUCCESS,
    CORE_LOAD_USERS_FAILURE,
    CORE_UPDATE_USER_REQUEST,
    CORE_UPDATE_USER_SUCCESS,
    CORE_UPDATE_USER_FAILURE,
    CORE_DELETE_USER_REQUEST,
    CORE_DELETE_USER_SUCCESS,
    CORE_DELETE_USER_FAILURE,
    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,
    CORE_LOAD_ROOMS_FAILURE,
    CORE_LOAD_REPORTSUMMARY_REQUEST,
    CORE_LOAD_REPORTSUMMARY_SUCCESS,
    CORE_LOAD_REPORTSUMMARY_FAILURE,
    CORE_UPDATE_ROOM_REQUEST,
    CORE_UPDATE_ROOM_SUCCESS,
    CORE_UPDATE_ROOM_FAILURE,
    CORE_LOAD_USER_INFO_REQUEST,
    CORE_LOAD_USER_INFO_SUCCESS,
    CORE_LOAD_USER_INFO_FAILURE,
    CORE_LOAD_SETTING_INFO_REQUEST,
    CORE_LOAD_SETTING_INFO_SUCCESS,
    CORE_LOAD_SETTING_INFO_FAILURE,
    CORE_LOAD_TERM_REQUEST,
    CORE_LOAD_TERM_SUCCESS,
    CORE_LOAD_TERM_FAILURE,
    CORE_UPDATE_TERM_REQUEST,
    CORE_UPDATE_TERM_SUCCESS,
    CORE_UPDATE_TERM_FAILURE,
    CORE_LOAD_FAQ_REQUEST,
    CORE_LOAD_FAQ_SUCCESS,
    CORE_LOAD_FAQ_FAILURE,
    CORE_LOAD_CONTACT_US_REQUEST,
    CORE_LOAD_CONTACT_US_SUCCESS,
    CORE_LOAD_CONTACT_US_FAILURE,
    CORE_LOAD_REPORTROOMSTATUS_REQUEST,
    CORE_LOAD_REPORTROOMSTATUS_SUCCESS,
    CORE_LOAD_REPORTROOMSTATUS_FAILURE,
    CORE_LOAD_ROOMDETAIL_REQUEST,
    CORE_LOAD_ROOMDETAIL_SUCCESS,
    CORE_LOAD_ROOMDETAIL_FAILURE,
    CORE_LOAD_ALL_CATEGORY_REQUEST,
    CORE_LOAD_ALL_CATEGORY_SUCCESS,
    CORE_LOAD_ALL_CATEGORY_FAILURE,
    CORE_LOAD_FBSINFO_REQUEST,
    CORE_LOAD_FBSINFO_SUCCESS,
    CORE_LOAD_FBSINFO_FAILURE,
    CORE_DELETE_FBS_REQUEST,
    CORE_DELETE_FBS_SUCCESS,
    CORE_DELETE_FBS_FAILURE,
    CORE_LOAD_LOCATIONS_REQUEST,
    CORE_LOAD_LOCATIONS_SUCCESS,
    CORE_LOAD_LOCATIONS_FAILURE,
    CORE_LOAD_AMENITYINFO_REQUEST,
    CORE_LOAD_AMENITYINFO_SUCCESS,
    CORE_LOAD_AMENITYINFO_FAILURE,
    BSRS_LOGIN_FAILURE,
    BSRS_LOGIN_REQUEST,
    SET_ERROR,
    CORE_LOAD_ALLFLOOR_REQUEST,
    CORE_LOAD_ALLFLOOR_SUCCESS,
    CORE_LOAD_ALLFLOOR_FAILURE,
    CORE_LOAD_FLOORINFO_REQUEST,
    CORE_LOAD_FLOORINFO_SUCCESS,
    CORE_LOAD_FLOORINFO_FAILURE,
    CORE_LOAD_ALLBUILDING_REQUEST,
    CORE_LOAD_ALLBUILDING_SUCCESS,
    CORE_LOAD_ALLBUILDING_FAILURE,
    CORE_LOAD_BUILDINGINFO_REQUEST,
    CORE_LOAD_BUILDINGINFO_SUCCESS,
    CORE_LOAD_BUILDINGINFO_FAILURE,
    CORE_LOAD_ALLBACKGROUND_REQUEST,
    CORE_LOAD_ALLBACKGROUND_SUCCESS,
    CORE_LOAD_ALLBACKGROUND_FAILURE,
    CORE_DELETE_BACKGROUND_REQUEST,
    CORE_DELETE_BACKGROUND_SUCCESS,
    CORE_DELETE_BACKGROUND_FAILURE,
    CORE_LOAD_BACKGROUNDINFO_REQUEST,
    CORE_LOAD_BACKGROUNDINFO_SUCCESS,
    CORE_LOAD_BACKGROUNDINFO_FAILURE,
    CORE_UPDATE_BACKGROUNDINFO_REQUEST,
    CORE_UPDATE_BACKGROUNDINFO_SUCCESS,
    CORE_UPDATE_BACKGROUNDINFO_FAILURE,
    CORE_CREATE_BACKGROUND_REQUEST,
    CORE_CREATE_BACKGROUND_SUCCESS,
    CORE_CREATE_BACKGROUND_FAILURE,
    CORE_DELETE_BUILDING_REQUEST,
    CORE_DELETE_BUILDING_SUCCESS,
    CORE_DELETE_BUILDING_FAILURE,
    CORE_UPDATE_BUILDINGINFO_REQUEST,
    CORE_UPDATE_BUILDINGINFO_SUCCESS,
    CORE_UPDATE_BUILDINGINFO_FAILURE,
    CORE_CREATE_BUILDING_REQUEST,
    CORE_CREATE_BUILDING_SUCCESS,
    CORE_CREATE_BUILDING_FAILURE,
    CORE_DELETE_FLOOR_REQUEST,
    CORE_DELETE_FLOOR_SUCCESS,
    CORE_DELETE_FLOOR_FAILURE,
    CORE_UPDATE_FLOORINFO_REQUEST,
    CORE_UPDATE_FLOORINFO_SUCCESS,
    CORE_UPDATE_FLOORINFO_FAILURE,
    CORE_CREATE_FLOOR_REQUEST,
    CORE_CREATE_FLOOR_SUCCESS,
    CORE_CREATE_FLOOR_FAILURE,
    CORE_LOAD_ALLZONE_REQUEST,
    CORE_LOAD_ALLZONE_SUCCESS,
    CORE_LOAD_ALLZONE_FAILURE,
    CORE_DELETE_ZONE_REQUEST,
    CORE_DELETE_ZONE_SUCCESS,
    CORE_DELETE_ZONE_FAILURE,
    CORE_LOAD_ZONEINFO_REQUEST,
    CORE_LOAD_ZONEINFO_SUCCESS,
    CORE_LOAD_ZONEINFO_FAILURE,
    CORE_UPDATE_ZONEINFO_REQUEST,
    CORE_UPDATE_ZONEINFO_SUCCESS,
    CORE_UPDATE_ZONEINFO_FAILURE,
    CORE_CREATE_ZONE_REQUEST,
    CORE_CREATE_ZONE_SUCCESS,
    CORE_CREATE_ZONE_FAILURE,
    CORE_UPDATE_FB_CATEGORY_REQUEST,
    CORE_UPDATE_FB_CATEGORY_SUCCESS,
    CORE_UPDATE_FB_CATEGORY_FAILURE,
    CORE_GET_CATEGORY_INFO_REQUEST,
    CORE_GET_CATEGORY_INFO_SUCCESS,
    CORE_GET_CATEGORY_INFO_FAILURE,
    CORE_CREATE_FB_CATEGORY_REQUEST,
    CORE_CREATE_FB_CATEGORY_SUCCESS,
    CORE_CREATE_FB_CATEGORY_FAILURE,
    CORE_DELETE_FB_CATEGORY_REQUEST,
    CORE_DELETE_FB_CATEGORY_SUCCESS,
    CORE_DELETE_FB_CATEGORY_FAILURE,
    CORE_CREATE_ROOM_REQUEST,
    CORE_CREATE_ROOM_SUCCESS,
    CORE_CREATE_ROOM_FAILURE,
    O365_LOAD_ROOMS_REQUEST,
    O365_LOAD_ROOMS_SUCCESS,
    O365_LOAD_ROOMS_FAILURE,
    CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST,
    CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS,
    CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE,
    O365_DELETE_ROOM_SUBSCRIBE_REQUEST,
    O365_DELETE_ROOM_SUBSCRIBE_SUCCESS,
    O365_DELETE_ROOM_SUBSCRIBE_FAILURE,
    O365_CREATE_ROOM_SUBSCRIBE_REQUEST,
    O365_CREATE_ROOM_SUBSCRIBE_SUCCESS,
    O365_CREATE_ROOM_SUBSCRIBE_FAILURE,
    CORE_LOAD_ALLFBS_REQUEST,
    CORE_LOAD_ALLFBS_SUCCESS,
    CORE_LOAD_ALLFBS_FAILURE,
    CORE_UPDATE_FBSINFO_REQUEST,
    CORE_UPDATE_FBSINFO_SUCCESS,
    CORE_UPDATE_FBSINFO_FAILURE,
    CORE_CREATE_FBS_REQUEST,
    CORE_CREATE_FBS_SUCCESS,
    CORE_CREATE_FBS_FAILURE,
    CORE_LOAD_USERGROUPS_REQUEST,
    CORE_LOAD_USERGROUPS_SUCCESS,
    CORE_LOAD_USERGROUPS_FAILURE,
    CORE_LOAD_LIST_USERGROUPS_REQUEST,
    CORE_LOAD_LIST_USERGROUPS_SUCCESS,
    CORE_LOAD_LIST_USERGROUPS_FAILURE,
    CORE_LOAD_USERGROUP_REQUEST,
    CORE_LOAD_USERGROUP_SUCCESS,
    CORE_LOAD_USERGROUP_FAILURE,
    CORE_CREATE_USERGROUP_REQUEST,
    CORE_CREATE_USERGROUP_SUCCESS,
    CORE_CREATE_USERGROUP_FAILURE,
    CORE_UPDATE_USERGROUP_REQUEST,
    CORE_UPDATE_USERGROUP_SUCCESS,
    CORE_UPDATE_USERGROUP_FAILURE,
    CORE_DELETE_USERGROUP_REQUEST,
    CORE_DELETE_USERGROUP_SUCCESS,
    CORE_DELETE_USERGROUP_FAILURE,
    CORE_CHANGE_SETTING_REQUEST,
    CORE_CHANGE_SETTING_SUCCESS,
    CORE_CHANGE_SETTING_FAILURE,
    CORE_CHECK_AD_REQUEST,
    CORE_CHECK_AD_SUCCESS,
    CORE_CHECK_AD_FAILURE,
    CORE_CREATE_USER_REQUEST,
    CORE_CREATE_USER_SUCCESS,
    CORE_CREATE_USER_FAILURE,
    CORE_CHANGE_PASSWORD_REQUEST,
    CORE_CHANGE_PASSWORD_SUCCESS,
    CORE_CHANGE_PASSWORD_FAILURE,
    O365_LOAD_USERS_REQUEST,
    O365_LOAD_USERS_SUCCESS,
    O365_LOAD_USERS_FAILURE,
    CORE_LOAD_ALL_USERSAD_REQUEST,
    CORE_LOAD_ALL_USERSAD_SUCCESS,
    CORE_LOAD_ALL_USERSAD_FAILURE,
    CORE_LOAD_ALL_PROFILE_REQUEST,
    CORE_LOAD_ALL_PROFILE_SUCCESS,
    CORE_LOAD_ALL_PROFILE_FAILURE,
    CORE_CREATE_PROFILE_REQUEST,
    CORE_CREATE_PROFILE_SUCCESS,
    CORE_CREATE_PROFILE_FAILURE,
    CORE_DELETE_PROFILE_REQUEST,
    CORE_DELETE_PROFILE_SUCCESS,
    CORE_DELETE_PROFILE_FAILURE,
    CORE_LOAD_PROFILE_INFO_REQUEST,
    CORE_LOAD_PROFILE_INFO_SUCCESS,
    CORE_LOAD_PROFILE_INFO_FAILURE,
    CORE_UPDATE_PROFILE_REQUEST,
    CORE_UPDATE_PROFILE_SUCCESS,
    CORE_UPDATE_PROFILE_FAILURE,
    CORE_UPDATE_DEFAULTBACKGROUND_REQUEST,
    CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS,
    CORE_UPDATE_DEFAULTBACKGROUND_FAILURE,
    CORE_LOAD_ALLAMENITY_REQUEST,
    CORE_LOAD_ALLAMENITY_SUCCESS,
    CORE_LOAD_ALLAMENITY_FAILURE,
    CORE_DELETE_AMENITY_REQUEST,
    CORE_DELETE_AMENITY_SUCCESS,
    CORE_DELETE_AMENITY_FAILURE,
    CORE_UPDATE_AMENITYINFO_REQUEST,
    CORE_UPDATE_AMENITYINFO_SUCCESS,
    CORE_UPDATE_AMENITYINFO_FAILURE,
    CORE_CREATE_AMENITY_REQUEST,
    CORE_CREATE_AMENITY_SUCCESS,
    CORE_CREATE_AMENITY_FAILURE,
    CORE_SEARCH_ROOMS_REQUEST,
    CORE_SEARCH_ROOMS_SUCCESS,
    CORE_SEARCH_ROOMS_FAILURE,
    CORE_SEARCH_FLOOR_REQUEST,
    CORE_SEARCH_FLOOR_SUCCESS,
    CORE_SEARCH_FLOOR_FAILURE,
    CORE_SEARCH_ZONE_REQUEST,
    CORE_SEARCH_ZONE_SUCCESS,
    CORE_SEARCH_ZONE_FAILURE,
    CORE_SEARCH_USERS_REQUEST,
    CORE_SEARCH_USERS_SUCCESS,
    CORE_SEARCH_USERS_FAILURE,
    CORE_SEARCH_FBS_REQUEST,
    CORE_SEARCH_FBS_SUCCESS,
    CORE_SEARCH_FBS_FAILURE,

    CORE_CHECKIN_REQUEST,
    CORE_CHECKIN_SUCCESS,
    CORE_CHECKIN_FAILURE,
    CORE_DELETE_EVENT_REQUEST,
    CORE_DELETE_EVENT_SUCCESS,
    CORE_DELETE_EVENT_FAILURE,
    CORE_CHECKOUT_REQUEST,
    CORE_CHECKOUT_SUCCESS,
    CORE_CHECKOUT_FAILURE,
    CORE_RESET_PASSWORD_REQUEST,
    CORE_RESET_PASSWORD_SUCCESS,
    CORE_RESET_PASSWORD_FAILURE,

    CORE_LOAD_DISPLAY_REQUEST,
    CORE_LOAD_DISPLAY_SUCCESS,
    CORE_LOAD_DISPLAY_FAILURE,
    CORE_UPDATE_DISPLAY_REQUEST,
    CORE_UPDATE_DISPLAY_SUCCESS,
    CORE_UPDATE_DISPLAY_FAILURE,

    CORE_LOAD_ALL_ROOMDISABLE_REQUEST,
    CORE_LOAD_ALL_ROOMDISABLE_SUCCESS,
    CORE_LOAD_ALL_ROOMDISABLE_FAILURE,
    CORE_LOAD_ROOMDISABLE_REQUEST,
    CORE_LOAD_ROOMDISABLE_SUCCESS,
    CORE_LOAD_ROOMDISABLE_FAILURE,
    CORE_CREATE_ROOMDISABLE_REQUEST,
    CORE_CREATE_ROOMDISABLE_SUCCESS,
    CORE_CREATE_ROOMDISABLE_FAILURE,
    CORE_UPDATE_ROOMDISABLE_REQUEST,
    CORE_UPDATE_ROOMDISABLE_SUCCESS,
    CORE_UPDATE_ROOMDISABLE_FAILURE,
    CORE_DELETE_ROOMDISABLE_REQUEST,
    CORE_DELETE_ROOMDISABLE_SUCCESS,
    CORE_DELETE_ROOMDISABLE_FAILURE,


    CORE_DELETE_CONCURRENT_REQUEST,
    CORE_DELETE_CONCURRENT_SUCCESS,
    CORE_DELETE_CONCURRENT_FAILURE,

    CORE_CHECK_TMS_REQUEST,
    CORE_CHECK_TMS_SUCCESS,
    CORE_CHECK_TMS_FAILURE,
    CORE_CHECK_CMR_REQUEST,
    CORE_CHECK_CMR_SUCCESS,
    CORE_CHECK_CMR_FAILURE,
    CORE_CHECK_BOT_REQUEST,
    CORE_CHECK_BOT_SUCCESS,
    CORE_CHECK_BOT_FAILURE,

    CORE_LOAD_ORDER_AMENITY_REQUEST,
    CORE_LOAD_ORDER_AMENITY_SUCCESS,
    CORE_LOAD_ORDER_AMENITY_FAILURE,

    O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST,
    O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS,
    O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE,

    CORE_CREATE_ORDER_REQUEST,
    CORE_CREATE_ORDER_SUCCESS,
    CORE_CREATE_ORDER_FAILURE,

    // CORE_LOAD_ALL_AD_LIST_REQUEST,
    // CORE_LOAD_ALL_AD_LIST_SUCCESS,
    CORE_LOAD_ALL_AD_LIST_FAILURE,

    // CORE_IMPORT_USER_AD_REQUEST,
    // CORE_IMPORT_USER_AD_SUCCESS,
    CORE_IMPORT_USER_AD_FAILURE,

    CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST,
    CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS,
    CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE,

    CORE_SEARCH_BUILDING_REQUEST,
    CORE_SEARCH_BUILDING_SUCCESS,
    CORE_SEARCH_BUILDING_FAILURE,

    CORE_SEARCH_AMENITY_REQUEST,
    CORE_SEARCH_AMENITY_SUCCESS,
    CORE_SEARCH_AMENITY_FAILURE,

    CORE_LOAD_ORDER_FBS_INFO_REQUEST,
    CORE_LOAD_ORDER_FBS_INFO_SUCCESS,
    CORE_LOAD_ORDER_FBS_INFO_FAILURE,

    CORE_LOAD_TOPROOMRESERVE_REQUEST,
    CORE_LOAD_TOPROOMRESERVE_SUCCESS,
    CORE_LOAD_TOPROOMRESERVE_FAILURE,

    CORE_LOAD_TOPUSERRESERVE_REQUEST,
    CORE_LOAD_TOPUSERRESERVE_SUCCESS,
    CORE_LOAD_TOPUSERRESERVE_FAILURE,

    CORE_SEARCH_EVENTTYPE_REQUEST,
    CORE_SEARCH_EVENTTYPE_SUCCESS,
    CORE_SEARCH_EVENTTYPE_FAILURE,

    O365_RESEND_EVENT_PIN_REQUEST,
    O365_RESEND_EVENT_PIN_SUCCESS,
    O365_RESEND_EVENT_PIN_FAILURE,

    CORE_CREATE_ROLE_REQUEST,
    CORE_CREATE_ROLE_SUCCESS,
    CORE_CREATE_ROLE_FAILURE,

    CORE_UPDATE_ROLE_REQUEST,
    CORE_UPDATE_ROLE_SUCCESS,
    CORE_UPDATE_ROLE_FAILURE,

    CORE_DELETE_ROLE_REQUEST,
    CORE_DELETE_ROLE_SUCCESS,
    CORE_DELETE_ROLE_FAILURE,
} from '../../types'

const initialState = {
    hasError: false,
    isLoading: false,
    error: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CORE_DELETE_ROLE_REQUEST:
        case CORE_UPDATE_ROLE_REQUEST:
        case CORE_CREATE_ROLE_REQUEST:
        case CORE_CREATE_ORDER_REQUEST:
        case CORE_LOAD_USER_INFO_REQUEST:
        case O365_REGISTER_REQUEST:
        case CORE_DELETE_ROOM_REQUEST:
        case O365_LOAD_EVENTS_REQUEST:
        case O365_LOAD_EVENT_REQUEST:
        case O365_LOAD_USER_INFO_REQUEST:
        case O365_CREATE_EVENT_REQUEST:
        case O365_DELETE_EVENT_REQUEST:
        case O365_ACCEPT_EVENT_REQUEST:
        case O365_TENTATIVE_EVENT_REQUEST:
        case O365_DECLINE_EVENT_REQUEST:
        case CORE_LOAD_ORDERS_REQUEST:
        case CORE_FIND_ROOM_REQUEST:
        case CORE_LOAD_USER_REQUEST:
        case CORE_UPDATE_USER_REQUEST:
        case CORE_DELETE_USER_REQUEST:
        case CORE_LOAD_USERS_REQUEST:
        case CORE_LOAD_ROOMS_REQUEST:
        case CORE_UPDATE_ROOM_REQUEST:
        case CORE_LOAD_SETTING_INFO_REQUEST:
        case CORE_LOAD_TERM_REQUEST:
        case CORE_UPDATE_TERM_REQUEST:
        case CORE_LOAD_FAQ_REQUEST:
        case CORE_LOAD_CONTACT_US_REQUEST:
        case CORE_LOAD_REPORTROOMSTATUS_REQUEST:
        case CORE_LOAD_ROOMDETAIL_REQUEST:
        case BSRS_LOGIN_REQUEST:
        case CORE_LOAD_ALL_CATEGORY_REQUEST:
        case CORE_LOAD_FBSINFO_REQUEST:
        case CORE_DELETE_FBS_REQUEST:
        case CORE_LOAD_LOCATIONS_REQUEST:
        case CORE_LOAD_AMENITYINFO_REQUEST:
        case CORE_LOAD_ALLFLOOR_REQUEST:
        case CORE_LOAD_FLOORINFO_REQUEST:
        case CORE_LOAD_ALLBUILDING_REQUEST:
        case CORE_LOAD_BUILDINGINFO_REQUEST:
        case CORE_LOAD_ALLBACKGROUND_REQUEST:
        case CORE_DELETE_BACKGROUND_REQUEST:
        case CORE_LOAD_BACKGROUNDINFO_REQUEST:
        case CORE_UPDATE_BACKGROUNDINFO_REQUEST:
        case CORE_CREATE_BACKGROUND_REQUEST:
        case CORE_DELETE_BUILDING_REQUEST:
        case CORE_UPDATE_BUILDINGINFO_REQUEST:
        case CORE_CREATE_BUILDING_REQUEST:
        case CORE_DELETE_FLOOR_REQUEST:
        case CORE_UPDATE_FLOORINFO_REQUEST:
        case CORE_CREATE_FLOOR_REQUEST:
        case CORE_LOAD_ALLZONE_REQUEST:
        case CORE_DELETE_ZONE_REQUEST:
        case CORE_LOAD_ZONEINFO_REQUEST:
        case CORE_UPDATE_ZONEINFO_REQUEST:
        case CORE_CREATE_ZONE_REQUEST:
        case CORE_UPDATE_FB_CATEGORY_REQUEST:
        case CORE_GET_CATEGORY_INFO_REQUEST:
        case CORE_CREATE_FB_CATEGORY_REQUEST:
        case CORE_DELETE_FB_CATEGORY_REQUEST:
        case CORE_CREATE_ROOM_REQUEST:
        case O365_LOAD_ROOMS_REQUEST:
        case CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST:
        case O365_DELETE_ROOM_SUBSCRIBE_REQUEST:
        case O365_CREATE_ROOM_SUBSCRIBE_REQUEST:
        case CORE_LOAD_ALLFBS_REQUEST:
        case CORE_UPDATE_FBSINFO_REQUEST:
        case CORE_CREATE_FBS_REQUEST:
        case CORE_LOAD_USERGROUPS_REQUEST:
        case CORE_LOAD_LIST_USERGROUPS_REQUEST:
        case CORE_LOAD_USERGROUP_REQUEST:
        case CORE_CREATE_USERGROUP_REQUEST:
        case CORE_UPDATE_USERGROUP_REQUEST:
        case CORE_DELETE_USERGROUP_REQUEST:
        case CORE_CHANGE_SETTING_REQUEST:
        case CORE_CHECK_AD_REQUEST:
        case CORE_CREATE_USER_REQUEST:
        case CORE_CHANGE_PASSWORD_REQUEST:
        case O365_LOAD_USERS_REQUEST:
        case CORE_LOAD_ALL_USERSAD_REQUEST:
        case CORE_LOAD_ALL_PROFILE_REQUEST:
        case CORE_CREATE_PROFILE_REQUEST:
        case CORE_DELETE_PROFILE_REQUEST:
        case CORE_LOAD_PROFILE_INFO_REQUEST:
        case CORE_UPDATE_PROFILE_REQUEST:
        case CORE_UPDATE_DEFAULTBACKGROUND_REQUEST:
        case CORE_LOAD_ALLAMENITY_REQUEST:
        case CORE_DELETE_AMENITY_REQUEST:
        case CORE_UPDATE_AMENITYINFO_REQUEST:
        case CORE_CREATE_AMENITY_REQUEST:
        case CORE_LOAD_REPORTSUMMARY_REQUEST:
        case CORE_SEARCH_ROOMS_REQUEST:
        case CORE_SEARCH_FLOOR_REQUEST:
        case CORE_SEARCH_ZONE_REQUEST:
        case CORE_SEARCH_USERS_REQUEST:
        case CORE_SEARCH_FBS_REQUEST:
        case CORE_CHECKIN_REQUEST:
        case CORE_DELETE_EVENT_REQUEST:
        case CORE_CHECKOUT_REQUEST:
        case CORE_RESET_PASSWORD_REQUEST:
        case CORE_LOAD_DISPLAY_REQUEST:
        case CORE_UPDATE_DISPLAY_REQUEST:
        case CORE_LOAD_ALL_ROOMDISABLE_REQUEST:
        case CORE_LOAD_ROOMDISABLE_REQUEST:
        case CORE_CREATE_ROOMDISABLE_REQUEST:
        case CORE_UPDATE_ROOMDISABLE_REQUEST:
        case CORE_DELETE_ROOMDISABLE_REQUEST:
        case CORE_DELETE_CONCURRENT_REQUEST:
        case CORE_CHECK_TMS_REQUEST:
        case CORE_CHECK_CMR_REQUEST:
        case CORE_CHECK_BOT_REQUEST:
        case CORE_LOAD_ORDER_AMENITY_REQUEST:
        case O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST:
        case CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST:
        case CORE_SEARCH_BUILDING_REQUEST:
        case CORE_SEARCH_AMENITY_REQUEST:
        case CORE_LOAD_ORDER_FBS_INFO_REQUEST:
        case CORE_LOAD_TOPROOMRESERVE_REQUEST:
        case CORE_LOAD_TOPUSERRESERVE_REQUEST:
        case CORE_SEARCH_EVENTTYPE_REQUEST:
        case O365_RESEND_EVENT_PIN_REQUEST:
            return {
                ...state,
                isLoading: true,
                hasError: false,
                error: null,
            }
        case CORE_DELETE_ROLE_SUCCESS:
        case CORE_CREATE_ROLE_SUCCESS:
        case CORE_CREATE_ORDER_SUCCESS:
        case CORE_LOAD_USER_INFO_SUCCESS:
        case O365_REGISTER_SUCCESS:
        case O365_LOAD_EVENTS_SUCCESS:
        case O365_LOAD_EVENT_SUCCESS:
        case O365_LOAD_USER_INFO_SUCCESS:
        case O365_CREATE_EVENT_SUCCESS:
        case O365_DELETE_EVENT_SUCCESS:
        case O365_ACCEPT_EVENT_SUCCESS:
        case O365_TENTATIVE_EVENT_SUCCESS:
        case O365_DECLINE_EVENT_SUCCESS:
        case CORE_LOAD_ORDERS_SUCCESS:
        case CORE_FIND_ROOM_SUCCESS:
        case CORE_DELETE_ROOM_SUCCESS:
        case CORE_LOAD_USER_SUCCESS:
        case CORE_UPDATE_USER_SUCCESS:
        case CORE_DELETE_USER_SUCCESS:
        case CORE_LOAD_USERS_SUCCESS:
        case CORE_LOAD_ROOMS_SUCCESS:
        case CORE_UPDATE_ROOM_SUCCESS:
        case CORE_LOAD_SETTING_INFO_SUCCESS:
        case CORE_LOAD_TERM_SUCCESS:
        case CORE_UPDATE_TERM_SUCCESS:
        case CORE_LOAD_FAQ_SUCCESS:
        case CORE_LOAD_CONTACT_US_SUCCESS:
        case CORE_LOAD_REPORTROOMSTATUS_SUCCESS:
        case CORE_LOAD_ROOMDETAIL_SUCCESS:
        case CORE_LOAD_ALL_CATEGORY_SUCCESS:
        case CORE_LOAD_FBSINFO_SUCCESS:
        case CORE_DELETE_FBS_SUCCESS:
        case CORE_LOAD_LOCATIONS_SUCCESS:
        case CORE_LOAD_AMENITYINFO_SUCCESS:
        case CORE_LOAD_ALLFLOOR_SUCCESS:
        case CORE_LOAD_FLOORINFO_SUCCESS:
        case CORE_LOAD_ALLBUILDING_SUCCESS:
        case CORE_LOAD_BUILDINGINFO_SUCCESS:
        case CORE_LOAD_ALLBACKGROUND_SUCCESS:
        case CORE_DELETE_BACKGROUND_SUCCESS:
        case CORE_LOAD_BACKGROUNDINFO_SUCCESS:
        case CORE_UPDATE_BACKGROUNDINFO_SUCCESS:
        case CORE_CREATE_BACKGROUND_SUCCESS:
        case CORE_DELETE_BUILDING_SUCCESS:
        case CORE_UPDATE_BUILDINGINFO_SUCCESS:
        case CORE_CREATE_BUILDING_SUCCESS:
        case CORE_DELETE_FLOOR_SUCCESS:
        case CORE_UPDATE_FLOORINFO_SUCCESS:
        case CORE_CREATE_FLOOR_SUCCESS:
        case CORE_LOAD_ALLZONE_SUCCESS:
        case CORE_DELETE_ZONE_SUCCESS:
        case CORE_LOAD_ZONEINFO_SUCCESS:
        case CORE_UPDATE_ZONEINFO_SUCCESS:
        case CORE_CREATE_ZONE_SUCCESS:
        case CORE_UPDATE_FB_CATEGORY_SUCCESS:
        case CORE_GET_CATEGORY_INFO_SUCCESS:
        case CORE_CREATE_FB_CATEGORY_SUCCESS:
        case CORE_DELETE_FB_CATEGORY_SUCCESS:
        case CORE_CREATE_ROOM_SUCCESS:
        case O365_LOAD_ROOMS_SUCCESS:
        case CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS:
        case O365_DELETE_ROOM_SUBSCRIBE_SUCCESS:
        case O365_CREATE_ROOM_SUBSCRIBE_SUCCESS:
        case CORE_LOAD_ALLFBS_SUCCESS:
        case CORE_UPDATE_FBSINFO_SUCCESS:
        case CORE_CREATE_FBS_SUCCESS:
        case CORE_LOAD_USERGROUPS_SUCCESS:
        case CORE_LOAD_LIST_USERGROUPS_SUCCESS:
        case CORE_LOAD_USERGROUP_SUCCESS:
        case CORE_CREATE_USERGROUP_SUCCESS:
        case CORE_UPDATE_USERGROUP_SUCCESS:
        case CORE_DELETE_USERGROUP_SUCCESS:
        case CORE_CHANGE_SETTING_SUCCESS:
        case CORE_CHECK_AD_SUCCESS:
        case CORE_CREATE_USER_SUCCESS:
        case CORE_CHANGE_PASSWORD_SUCCESS:
        case O365_LOAD_USERS_SUCCESS:
        case CORE_LOAD_ALL_USERSAD_SUCCESS:
        case CORE_LOAD_ALL_PROFILE_SUCCESS:
        case CORE_CREATE_PROFILE_SUCCESS:
        case CORE_DELETE_PROFILE_SUCCESS:
        case CORE_LOAD_PROFILE_INFO_SUCCESS:
        case CORE_UPDATE_PROFILE_SUCCESS:
        case CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS:
        case CORE_LOAD_ALLAMENITY_SUCCESS:
        case CORE_DELETE_AMENITY_SUCCESS:
        case CORE_UPDATE_AMENITYINFO_SUCCESS:
        case CORE_CREATE_AMENITY_SUCCESS:
        case CORE_LOAD_REPORTSUMMARY_SUCCESS:
        case CORE_SEARCH_ROOMS_SUCCESS:
        case CORE_SEARCH_FLOOR_SUCCESS:
        case CORE_SEARCH_ZONE_SUCCESS:
        case CORE_SEARCH_USERS_SUCCESS:
        case CORE_SEARCH_FBS_SUCCESS:
        case CORE_CHECKIN_SUCCESS:
        case CORE_DELETE_EVENT_SUCCESS:
        case CORE_CHECKOUT_SUCCESS:
        case CORE_RESET_PASSWORD_SUCCESS:
        case CORE_LOAD_DISPLAY_SUCCESS:
        case CORE_UPDATE_DISPLAY_SUCCESS:
        case CORE_LOAD_ALL_ROOMDISABLE_SUCCESS:
        case CORE_LOAD_ROOMDISABLE_SUCCESS:
        case CORE_CREATE_ROOMDISABLE_SUCCESS:
        case CORE_UPDATE_ROOMDISABLE_SUCCESS:
        case CORE_DELETE_ROOMDISABLE_SUCCESS:
        case CORE_DELETE_CONCURRENT_SUCCESS:
        case CORE_CHECK_TMS_SUCCESS:
        case CORE_CHECK_CMR_SUCCESS:
        case CORE_CHECK_BOT_SUCCESS:
        case CORE_LOAD_ORDER_AMENITY_SUCCESS:
        case O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS:
        case CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS:
        case CORE_SEARCH_BUILDING_SUCCESS:
        case CORE_SEARCH_AMENITY_SUCCESS:
        case CORE_LOAD_ORDER_FBS_INFO_SUCCESS:
        case CORE_LOAD_TOPROOMRESERVE_SUCCESS:
        case CORE_LOAD_TOPUSERRESERVE_SUCCESS:
        case CORE_SEARCH_EVENTTYPE_SUCCESS:
        case O365_RESEND_EVENT_PIN_SUCCESS:
        case CORE_UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                // hasError: false,
                // error: null,
            }
        case CORE_DELETE_ROLE_FAILURE:
        case CORE_CREATE_ORDER_FAILURE:
        case CORE_LOAD_USER_INFO_FAILURE:
        case O365_LOAD_USER_INFO_FAILURE:
        case O365_LOAD_EVENT_FAILURE:
        case O365_LOAD_EVENTS_FAILURE:
        case O365_CREATE_EVENT_FAILURE:
        case O365_DELETE_EVENT_FAILURE:
        case O365_ACCEPT_EVENT_FAILURE:
        case O365_TENTATIVE_EVENT_FAILURE:
        case O365_DECLINE_EVENT_FAILURE:
        case CORE_LOAD_ORDERS_FAILURE:
        case CORE_FIND_ROOM_FAILURE:
        case CORE_DELETE_ROOM_FAILURE:
        case CORE_LOAD_USER_FAILURE:
        case CORE_UPDATE_USER_FAILURE:
        case CORE_DELETE_USER_FAILURE:
        case CORE_LOAD_USERS_FAILURE:
        case CORE_LOAD_ROOMS_FAILURE:
        case CORE_UPDATE_ROOM_FAILURE:
        case CORE_LOAD_SETTING_INFO_FAILURE:
        case CORE_LOAD_TERM_FAILURE:
        case CORE_UPDATE_TERM_FAILURE:
        case CORE_LOAD_FAQ_FAILURE:
        case CORE_LOAD_CONTACT_US_FAILURE:
        case CORE_LOAD_REPORTROOMSTATUS_FAILURE:
        case CORE_LOAD_ROOMDETAIL_FAILURE:
        case BSRS_LOGIN_FAILURE:
        case CORE_LOAD_ALL_CATEGORY_FAILURE:
        case CORE_LOAD_FBSINFO_FAILURE:
        case CORE_DELETE_FBS_FAILURE:
        case CORE_LOAD_LOCATIONS_FAILURE:
        case CORE_LOAD_AMENITYINFO_FAILURE:
        case CORE_LOAD_ALLFLOOR_FAILURE:
        case CORE_LOAD_FLOORINFO_FAILURE:
        case CORE_LOAD_ALLBUILDING_FAILURE:
        case CORE_LOAD_BUILDINGINFO_FAILURE:
        case CORE_LOAD_ALLBACKGROUND_FAILURE:
        case CORE_DELETE_BACKGROUND_FAILURE:
        case CORE_LOAD_BACKGROUNDINFO_FAILURE:
        case CORE_UPDATE_BACKGROUNDINFO_FAILURE:
        case CORE_CREATE_BACKGROUND_FAILURE:
        case CORE_DELETE_BUILDING_FAILURE:
        case CORE_UPDATE_BUILDINGINFO_FAILURE:
        case CORE_CREATE_BUILDING_FAILURE:
        case CORE_DELETE_FLOOR_FAILURE:
        case CORE_UPDATE_FLOORINFO_FAILURE:
        case CORE_CREATE_FLOOR_FAILURE:
        case CORE_LOAD_ALLZONE_FAILURE:
        case CORE_DELETE_ZONE_FAILURE:
        case CORE_LOAD_ZONEINFO_FAILURE:
        case CORE_UPDATE_ZONEINFO_FAILURE:
        case CORE_CREATE_ZONE_FAILURE:
        case CORE_UPDATE_FB_CATEGORY_FAILURE:
        case CORE_GET_CATEGORY_INFO_FAILURE:
        case CORE_CREATE_FB_CATEGORY_FAILURE:
        case CORE_DELETE_FB_CATEGORY_FAILURE:
        case CORE_CREATE_ROOM_FAILURE:
        case O365_LOAD_ROOMS_FAILURE:
        case CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE:
        case O365_DELETE_ROOM_SUBSCRIBE_FAILURE:
        case O365_CREATE_ROOM_SUBSCRIBE_FAILURE:
        case CORE_LOAD_ALLFBS_FAILURE:
        case CORE_UPDATE_FBSINFO_FAILURE:
        case CORE_CREATE_FBS_FAILURE:
        case CORE_LOAD_USERGROUPS_FAILURE:
        case CORE_LOAD_LIST_USERGROUPS_FAILURE:
        case CORE_LOAD_USERGROUP_FAILURE:
        case CORE_CREATE_USERGROUP_FAILURE:
        case CORE_UPDATE_USERGROUP_FAILURE:
        case CORE_DELETE_USERGROUP_FAILURE:
        case CORE_CHANGE_SETTING_FAILURE:
        case CORE_CHECK_AD_FAILURE:
        case CORE_CREATE_USER_FAILURE:
        case CORE_CHANGE_PASSWORD_FAILURE:
        case O365_LOAD_USERS_FAILURE:
        case CORE_LOAD_ALL_USERSAD_FAILURE:
        case CORE_LOAD_ALL_PROFILE_FAILURE:
        case CORE_CREATE_PROFILE_FAILURE:
        case CORE_DELETE_PROFILE_FAILURE:
        case CORE_LOAD_PROFILE_INFO_FAILURE:
        case CORE_UPDATE_PROFILE_FAILURE:
        case CORE_UPDATE_DEFAULTBACKGROUND_FAILURE:
        case CORE_LOAD_ALLAMENITY_FAILURE:
        case CORE_DELETE_AMENITY_FAILURE:
        case CORE_UPDATE_AMENITYINFO_FAILURE:
        case CORE_CREATE_AMENITY_FAILURE:
        case CORE_LOAD_REPORTSUMMARY_FAILURE:
        case CORE_SEARCH_ROOMS_FAILURE:
        case CORE_SEARCH_FLOOR_FAILURE:
        case CORE_SEARCH_ZONE_FAILURE:
        case CORE_SEARCH_USERS_FAILURE:
        case CORE_SEARCH_FBS_FAILURE:
        case CORE_CHECKIN_FAILURE:
        case CORE_DELETE_EVENT_FAILURE:
        case CORE_CHECKOUT_FAILURE:
        case CORE_RESET_PASSWORD_FAILURE:
        case CORE_LOAD_DISPLAY_FAILURE:
        case CORE_UPDATE_DISPLAY_FAILURE:
        case CORE_LOAD_ALL_ROOMDISABLE_FAILURE:
        case CORE_LOAD_ROOMDISABLE_FAILURE:
        case CORE_CREATE_ROOMDISABLE_FAILURE:
        case CORE_UPDATE_ROOMDISABLE_FAILURE:
        case CORE_DELETE_ROOMDISABLE_FAILURE:
        case CORE_DELETE_CONCURRENT_FAILURE:
        case CORE_CHECK_TMS_FAILURE:
        case CORE_CHECK_CMR_FAILURE:
        case CORE_CHECK_BOT_FAILURE:
        case CORE_LOAD_ORDER_AMENITY_FAILURE:
        case O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE:
        case CORE_LOAD_ALL_AD_LIST_FAILURE:
        case CORE_IMPORT_USER_AD_FAILURE:
        case CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE:
        case CORE_SEARCH_BUILDING_FAILURE:
        case CORE_SEARCH_AMENITY_FAILURE:
        case CORE_LOAD_ORDER_FBS_INFO_FAILURE:
        case CORE_LOAD_TOPROOMRESERVE_FAILURE:
        case CORE_LOAD_TOPUSERRESERVE_FAILURE:
        case CORE_SEARCH_EVENTTYPE_FAILURE:
        case O365_RESEND_EVENT_PIN_FAILURE:
        case CORE_CREATE_ROLE_FAILURE:
        case CORE_UPDATE_ROLE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasError: true,
                error: action.payload.data,
            }
        case SET_ERROR:
            return {
                ...state,
                hasError: action.hasError,
                error: action.error
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js